import React from 'react';

const SubText = React.memo(({children}) => <div className="tile-square__content-block--sub-text">{children}</div>);

export default SubText;
